import React, { useEffect, useState } from 'react';
import { Clock, ShieldCheck } from 'lucide-react';
export function StickyBars() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show bottom bar after scrolling past the hero
      if (window.scrollY > 400) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <>
      {/* Top Urgency Bar */}
      <div className="fixed top-0 left-0 right-0 bg-red-600 text-white z-50 shadow-md" data-id="element-225">
        <div className="max-w-4xl mx-auto px-4 py-2 flex flex-col sm:flex-row items-center justify-center sm:justify-between text-sm font-medium gap-2" data-id="element-226">
          <div className="flex items-center gap-2" data-id="element-227">
            <Clock className="w-4 h-4 animate-pulse" data-id="element-228" />
            <span data-id="element-229">OFERTA DE HOY: $6.39 USD</span>
            <span className="hidden sm:inline mx-2 opacity-50" data-id="element-230">|</span>
            <span className="hidden sm:inline" data-id="element-231">Acceso inmediato 24/7</span>
          </div>
          <button onClick={() => document.getElementById('oferta')?.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })} className="bg-white text-red-600 px-4 py-1 rounded-full text-xs font-bold hover:bg-red-50 transition-colors uppercase tracking-wide" data-id="element-232">
            Obtener Ahora
          </button>
        </div>
      </div>

      {/* Bottom Sticky Bar (Mobile focused, but visible on desktop too for aggressive conversion) */}
      <div className={`fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] z-50 transition-transform duration-300 ${isVisible ? 'translate-y-0' : 'translate-y-full'}`} data-id="element-233">
        <div className="max-w-4xl mx-auto px-4 py-3 flex items-center justify-between gap-4" data-id="element-234">
          <div className="hidden sm:flex flex-col" data-id="element-235">
            <span className="text-slate-900 font-bold text-lg" data-id="element-236">
              Protocolo MIC
            </span>
            <div className="flex items-center gap-1 text-teal-700 text-sm font-medium" data-id="element-237">
              <ShieldCheck className="w-4 h-4" data-id="element-238" />
              <span data-id="element-239">Garantizado</span>
            </div>
          </div>

          <div className="flex items-center gap-4 w-full sm:w-auto" data-id="element-240">
            <div className="flex flex-col items-end hidden xs:flex" data-id="element-241">
              <span className="text-xs text-slate-500 line-through" data-id="element-242">
                $29.00
              </span>
              <span className="text-xl font-black text-red-600 leading-none" data-id="element-243">
                $6.39
              </span>
            </div>
            <button onClick={() => {
            window.location.href = 'https://wiselicecontrol.com/cart/43850281549890:1';
          }} className="flex-1 sm:flex-none bg-teal-600 hover:bg-teal-700 text-white font-bold py-3 px-6 rounded-lg shadow-md transition-colors text-center" data-id="element-244">
              ¡LO QUIERO AHORA!
            </button>
          </div>
        </div>
      </div>
    </>;
}